import BaseUseCase from "../base_use_case.js";

class LoadMenuItemsUseCase extends BaseUseCase {

  execute() {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/menu/items`,
    });
  }
}

const instance = new LoadMenuItemsUseCase();
export default instance;